import React from 'react'
import ListContestsVacancies from '../../../../../presentation/pages/doctors/list-contests-vacancies'

const MakeListContestsVacancies = () => <ListContestsVacancies />

export default MakeListContestsVacancies
